export default function (base, modifiers = []) {
  return [base].concat(modifiers.filter(str => str)).join(' ' + base + '--');
}
